import React, { Fragment, useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus, faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import NewAttachmentPopover from './NewAttachmentPopover/NewAttachmentPopover';
import {
  Input,
  Button,
  InputGroup,
  Popover,
  PopoverBody,
  PopoverHeader,
  UncontrolledPopover,
  Label,
  FormGroup,
  ButtonGroup,
} from 'reactstrap';
import { postDataAgnostic, putData, fetchDataAgnostic } from '../../../../../../../Services/dataApi';
import { DepartmentContext } from '../../../../../../../DepartmentWrapper';
import { useAuth0, Auth0Context } from '../../../../../../../auth0/reactAuth0Spa';
import style from '../AdminMessageComposer.style';
import {
  checkLoginForError,
  contactSupport,
  formatBearerToken,
  PopupWrapper,
} from '../../../../../../../Common.functions';
import SingleCandidateDragAndDropItem from 'Body/DragAndDropFiles/SingleCandidateDragAndDropItem';
import AttachmentItem from './AttachmentItem/AttachmentItem';

const AttachmentsPopover = ({
  uniqueId = '',
  addAttachment,
  setAttachmentsCount,
  html,
  setUniqueAttachmentsInTemplate,
}) => {
  const [documentSearchTerm, setDocumentSearchTerm] = useState('');
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [showNewAttachmentPopover, setShowNewAttachmentPopover] = useState(false);
  const [newAttachment, setNewAttachment] = useState({});

  const [isFetchingAttachments, setIsFetchingAttachments] = useState(false);
  const [attachments, setAttachments] = useState([
    { Name: 'Attachment 1' },
    { Name: 'Attachment 2' },
    { Name: 'Attachment 3' },
    { Name: 'Attachment 4' },
    { Name: 'Attachment 5' },
    { Name: 'Attachment 6' },
    { Name: 'Attachment 7' },
    { Name: 'Attachment 8' },
    { Name: 'Attachment 9' },
    { Name: 'Attachment 10' },
  ]);
  const [attachmentsInTemplate, setAttachmentsInTemplate] = useState(new Set());
  const hasSearchValues = true;

  const dContext = useContext(DepartmentContext);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  const initiateFileUpload = () => {
    console.log('here');
  };

  // Analyze editor content to find which attachments are in the template
  const analyzeAttachmentsInTemplate = () => {
    if (!attachments || attachments.length === 0) {
      return;
    }

    try {
      const templateHtml = html || '';

      // Determine the attachment URL based on environment
      const { REACT_APP_BUILD_TYPE } = process.env;
      let attachmentUrlBase = 'https://dev.rezrate.com/department/attachment/';

      if (REACT_APP_BUILD_TYPE && REACT_APP_BUILD_TYPE === 'liveproduction') {
        attachmentUrlBase = 'https://app.rezrate.com/department/attachment/';
      }

      if (REACT_APP_BUILD_TYPE && REACT_APP_BUILD_TYPE === 'livedevelopment') {
        attachmentUrlBase = 'https://dev.rezrate.com/department/attachment/';
      }

      // Find unique attachments in the template
      const foundUUIDs = new Set();
      attachments.forEach((attachment) => {
        const { DocumentUUID } = attachment;
        if (DocumentUUID) {
          const fullUrl = `${attachmentUrlBase}${DocumentUUID}`;
          if (templateHtml.includes(fullUrl)) {
            foundUUIDs.add(DocumentUUID);
          }
        }
      });

      setAttachmentsInTemplate(foundUUIDs);
      if (setUniqueAttachmentsInTemplate) {
        setUniqueAttachmentsInTemplate(foundUUIDs.size);
      }
    } catch (error) {
      console.error('Error analyzing attachments in template:', error);
    }
  };

  const getAttachments = () => {
    setIsFetchingAttachments(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/attachments',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((result) => {
            setIsFetchingAttachments(false);
            // console.log('getAttachments result.data: ', result.data);
            setAttachments(result.data);
            if (result.data) {
              setAttachmentsCount(result.data.length);
            } else {
              setAttachmentsCount(0);
            }
          })
          .catch((err) => {
            setIsFetchingAttachments(false);
          });
      })
      .catch((err) => {
        setIsFetchingAttachments(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  useEffect(() => {
    getAttachments();
  }, []);

  useEffect(() => {
    console.log('showNewAttachmentPopover change! :', showNewAttachmentPopover);
  }, [showNewAttachmentPopover]);

  // Analyze attachments whenever editor state or attachments list changes
  useEffect(() => {
    analyzeAttachmentsInTemplate();
  }, [html, attachments]);

  const renderNewAttachmentPopover = () => {
    const { Name = '', file } = newAttachment;
    const target = `newAttachmentBtn_${uniqueId}`;

    return (
      <NewAttachmentPopover
        target={target}
        showNewAttachmentPopover={showNewAttachmentPopover}
        getAttachments={getAttachments}
        setShowNewAttachmentPopover={(newValue) => {
          console.log('setShowNewAttachmentPopover firing!');
          setShowNewAttachmentPopover(newValue);
        }}
        uniqueId={uniqueId}
      />
    );
  };

  return (
    <div style={style.simpleRow} id={`attachmentsPopover_${uniqueId}`}>
      <div style={style.simpleColumn}>
        <div style={{ ...style.simpleRow, height: 200, overflowY: 'scroll', marginBottom: 5 }}>
          <div style={style.simpleColumn}>
            {isFetchingAttachments ? (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                Loading...
              </div>
            ) : (
              attachments.map((attachment, index) => {
                const isInTemplate = attachmentsInTemplate.has(attachment.DocumentUUID);
                return (
                  <AttachmentItem
                    key={attachment.pk_Attachment || index}
                    attachment={attachment}
                    attachmentIndex={index}
                    addAttachment={addAttachment}
                    getAttachments={getAttachments}
                    isInTemplate={isInTemplate}
                  />
                );
              })
            )}
          </div>
        </div>
        <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
          Insert Attachments by clicking the green arrow icon.
        </div>
        <div style={{ ...style.simpleRow, justifyContent: 'center', marginBottom: 10 }}>
          <a
            href="https://www.rezrate.com/knowledge-base/adding-attachments-to-your-email-templates/"
            target="_blank" rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
              // window.open(
              //   'https://www.rezrate.com/knowledge-base/adding-attachments-to-your-email-templates/',
              //   '_blank',
              // );
            }}
          >
            More information here.
          </a>
        </div>
        <div style={{ ...style.simpleRow, justifyContent: 'center', alignItems: 'center' }}>
          <Button
            size="sm"
            color="success"
            id={`newAttachmentBtn_${uniqueId}`}
            onClick={() => {
              console.log('new attachment button clicked!');
              setShowNewAttachmentPopover(!showNewAttachmentPopover);
            }}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 5 }} />
            Upload File to Library
            {renderNewAttachmentPopover()}
          </Button>
        </div>
      </div>
    </div>
  );
  return <SingleCandidateDragAndDropItem attachedDoc={{}} initiateFileUpload={initiateFileUpload} item={{}} />;
};

export default AttachmentsPopover;
